import cx from 'clsx';
import * as React from 'react';

import BannerGhost from '@/components/modular-grid/Banner/BannerGhost';
import GhostTile from '@/components/modular-grid/GhostTile/GhostTile';

import styles from './GameBanner.module.scss';

const GameBannerGhost: React.FC = () => {
  const createSlot = (key: number) => (
    <div className={cx(styles.slot, styles.rowSmall)} key={key}>
      <GhostTile />
    </div>
  );

  return (
    <div
      className={cx(
        styles.container,
        styles.insideHeader,
        styles.containerSmall,
        styles.containerMedium
      )}
      data-testid="game-banner-ghost-grid"
    >
      <div className={cx(styles.bannerMedium)}>
        <BannerGhost standalone={false} />
      </div>
      <div className={cx(styles.rowSmall, styles.rowMedium, styles.row)}>
        {Array.from(Array(6).keys()).map(index => createSlot(index))}
      </div>
    </div>
  );
};
export default GameBannerGhost;
